export const QUERY_STALE_TIME = 120000;
export const LONG_QUERY_STALE_TIME = 600000;
export const BREAKPOINT_SMALL_WIDTH = 330;
export const BREAKPOINT_MEDIUM_WIDTH = 621;
export const BREAKPOINT_LARGE_WIDTH = 990;
export const MAP_AUTH_TOKEN = 'user_auth_token';
export const MAP_SCHEDULE = 'schedule';
export const MAP_PUSHER = 'pusher';
export const MAP_SEGMENT_STATUS = 'segment_registration_status';
export const FEATURE_FLAGS = 'feature_flags';
export const MAP_SELECTED_LANGUAGE = 'selected_language';
export const MAP_AGENDA_ITEMS = 'agenda_items';
export const ANALYTIC_EVENTS = {
  SCHEDULE_ITEM_ADDED_TO_CALENDAR: 'schedule-item-added-to-calendar',
};
export const client = '@hopin-team/slices-shared';
export const NAVIGATION_ANALYTICS_EVENTS = {
  name: 'SCHEDULE_NAVIGATION',
  from: {
    inEvent: 'SCHEDULE_IN_EVENT',
    happeningNow: 'SCHEDULE_HAPPENING_NOW',
    scheduleReception: 'SCHEDULE_RECEPTION',
    guidedEvent: 'SCHEDULE_GUIDED_EVENT',
  },
};
